import BaseViewController from "./base-view-controller";

class ActivationAccountViewController extends BaseViewController {
  preprocessScreenData() {
    const { values, isPiiCollected, piiCollectedSuccess } = this.appData;

    if (!isPiiCollected) {
      const PII = new URLSearchParams(window.location.search);

      PII.forEach((value, key) => {
        if (!values.hasOwnProperty(key)) {
          values[key] = value;
        }
      });
      piiCollectedSuccess();
    }
  }
}

export default ActivationAccountViewController;
